module.exports = __webpack_public_path__ + "static/media/legge_sammen.5ab0c293.m4a";